/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true, // (action) => { return ‘trace as string’; }
      traceLimit: 25
    })) ||
  compose;

const logger = createLogger({
  collapsed: true,
  logErrors: true,
  level: 'info',
  diff: true,
  stateTransformer: (state) => {
    const newState = {};

    Object.keys(state).forEach((key) => {
      if (key === 'tourReducer') {
        const { tourReducer } = state;
        newState.tourReducer = {
          ...tourReducer,
          modalTour: tourReducer.modalTour
            ? {
                id: tourReducer.modalTour.id,
                steps: tourReducer.modalTour.steps.map((step) => step.id)
              }
            : null,
          mainTour: tourReducer.mainTour
            ? {
                id: tourReducer.mainTour.id,
                steps: tourReducer.mainTour.steps.map((step) => step.id)
              }
            : null
        };
      } else {
        newState[key] = state[key];
      }
    });

    return newState;
  }
});

const configureStore = (initialState) => {
  const middleWare =
    process.env.NODE_ENV === `development` ? [thunk, logger] : [thunk];
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleWare))
  );

  return store;
};
const store = configureStore({});

export default store;
